export const GLOW = {
  frontalUpload: "upload-frontal",
  lateralUpload: "upload-lateral",
  frontalInput: "input-frontal",
  lateralInput: "input-lateral",
  nomeInput: "lead-nome",
  cognomeInput: "lead-cognome",
  cellulareInput: "lead-cellulare",
  emailInput: "lead-email",
  analyzeButton: "analyze-button",
  loadingState: "analysis-loading",
  errorMessage: "analysis-error",
  reportPage: "report-page",
  scoreRing: "glow-score-ring",
  scoreValue: "glow-score-value",
  basicCart: "cart-basic",
  premiumCart: "cart-premium",
  retryButton: "retry-button",
  shareButton: "share-button",
  adminKeyInput: "admin-key-input",
  adminLoginButton: "admin-login-button",
  adminReportsList: "admin-reports-list",
};
